import http from "@/http"
import storage from "./storage";

const cacheKey = "DEVICE_ID_2_UNIT_ID"

export function getUnitId(deviceId) {
    const unitId = getCache()[deviceId]
    return unitId
}

export function setUnitId(deviceId, unitId) {
    const cache = getCache()

    if (unitId != null || unitId !== undefined) {
        cache[deviceId] = unitId;
        storage.setCache(cacheKey, cache)
    } else {
        http.tokiot.device.get({id: deviceId})
            .then(ret => {
                cache[deviceId] = ret.unitId;
                storage.setCache(cacheKey, cache)
            })
    }

}

function getCache() {
    return storage.getCache(cacheKey) || {}
}